import React from "react";

import { LinkExpiredBlock } from "../../../LinkExpiredBlock/LinkExpiredBlock";
import { SuccessBlock } from "../../../SuccessBlock/SuccessBlock";

export function FormHandler({ pageHandler, successMessage = undefined }) {
  switch (pageHandler) {
    case "expired":
      return <LinkExpiredBlock />;
    case "success":
      return <SuccessBlock successMessage={successMessage} />;
    default:
      return null;
  }
}
